import React, { useState, useEffect } from "react";
import Navbar from "../Navigationbar/Navbar";
import { Outlet } from "react-router-dom";
import Sidebar from "../Navigationbar/Sidebar";

const DefaultLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSidebarOpen]);
  return (
    <>
      <div className="h-screen bg-background overflow-hidden font-sans text-foreground">
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="flex">
          <div className="mt-16 md:mt-20">
            <Sidebar isOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
          </div>
          <main
            className={`flex-1 overflow-y-auto custom-scrollbar px-4 py-4 sm:px-5 md:px-6 lg:px-8 relative lg:ml-72 min-h-[calc(100vh-4rem)] max-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-5rem)] md:max-h-[calc(100vh-5rem)] transition-opacity duration-300 ${
              isSidebarOpen ? "opacity-50 lg:opacity-100" : "opacity-100"
            }`}
          >
            <div className="mx-auto w-full max-w-[1400px]">
              <Outlet />
            </div>
          </main>
        </div>
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-foreground/60 z-30 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          ></div>
        )}
      </div>
    </>
  );
};

export default DefaultLayout;
